import {useEffect, useState} from 'react';

import {useDispatch} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import {IsRecalibration} from '@/actions/setupActions';
import axiosMethods from '@/api/apiManager';
import * as APPDATA from '@/constants/pcConstAppData';

function RecalibrationSystem() {
  const dispatch = useDispatch();

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    axiosMethods.get(APPDATA.API.IS_CALIBRATION_REQUIRED).then((response) => {
      if (response.data) {
        setShowPopup(true);
      }
    });
  }, []);

  const RecalibrationPopup = () => {
    const popUpButton = [
      {
        id: APPDATA.CALIBRATION_LOAD_CELL_CALIBRATE_SCALE,
        isPrimaryButton: true,
        onClick: onClickPopUpButton,
        label: APPDATA.CALIBRATION_LOAD_CELL_CALIBRATE_SCALE,
        disabled: false,
      },
    ];
    dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RECALIBRATION.TITLE,
        popUpText: APPDATA.MESSAGES.CALIBRATION_LOAD_CELL_WIZARD.RECALIBRATION.TEXT,
        popUpButton,
        popUpHideCloseButton: true,
        popUpClose: closePopup,
      }),
    );
  };

  const closePopup = () => {
    setShowPopup(false);
    dispatch(modalActions.hidePopUp());
  };

  const onClickPopUpButton = () => {
    closePopup();
    dispatch(IsRecalibration(true));
    window.location.href = APPDATA.CALIBRATION_LOAD_CELL_SENSOR_CALIBRATE_SCALE_ADDRESS;
  };

  if (!showPopup) return null;

  return RecalibrationPopup();
}

export default RecalibrationSystem;
